import React from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

const ReadmoreLabel: React.FC = () => {
  const { t } = useTranslation();

  return (
    <span className="ReadmoreLabel">{t('general.read_more')}</span>
  );
};

export default ReadmoreLabel;
